module.exports = __webpack_public_path__ + "img/w3_check_white.b4fdf4ad.png";